import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { listUsers, createUser, updateUser, deleteUser, SendEmail } from '../api/users';
import { BsFillUsbPlugFill, BsPerson, BsBuilding, BsPencil } from 'react-icons/bs';
import PageHeader from '../components/PageHeader';
import StatCard from '../components/StatCard';
import Table from '../components/Table';
import Button from '../components/Button';
import Input from '../components/Input';
import Select from '../components/Select';
import Snackbar from '../components/Snackbar';
import UserDialog from '../components/UserDialog';
import UsersAction from '../components/UsersAction';
import { BsMailbox } from 'react-icons/bs';
import PageHeaderPortal from '../components/PageHeaderPortal';

import { data } from 'react-router-dom';
export default function Users() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({
    us_name: '',
    us_login: '',
    RoleId: '',
    companyId: '',
    acountType: '',
    email:'',
    us_type:''
   
  });
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
  const [q, setQ] = useState('');
  const [roleFilter, setRoleFilter] = useState('all');
  const [activeFilter, setActiveFilter] = useState('all');
  const [options, setOptions] = useState({ roles: [], companies: [], users: [] });
  
  
  
  useEffect(() => {
   
      setLoading(true);
      fetch("https://hs2api.razamit.pl/comprole") // <-- Twój endpoint
        .then((res) => res.json())
        .then((data) => {
          setOptions({
            roles: data.roles || [],
            companies: data.companies || [],
          });
        })
        .catch((err) => console.error("Błąd pobierania danych:", err))
        .finally(() => setLoading(false));
    
  }, []);


  const fetchData = async () => {
    
    setLoading(true);
    try {
      const data = await listUsers();
      const mapped = data.map(item => ({
        id: item.usesrID,
        us_name: item.us_name,                // ← nazwa licencji
        us_login: item.us_login,          // ← klient
        is_active: item.is_active, 
        RoleId: item.RoleId,
        companyId: item.companyId,          // ← opiekun
        role_name:  item.role_name,  // ← data wygasania
        CompnyName: item.CompnyName, // ← data istatniego logowanai
        CompanyNIP: item.CompanyNIP,
        acountType: item.acountType,
       acountTypeName: item.acountTypeName,
       email: item.email,
       us_type: item.us_type
      }));
      setRows(mapped);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const onEdit = useCallback((row) => {
    setEditing(row);
    setForm({ ...row });
    setOpen(true);
  }, []);

  const onSendUserData = useCallback(async (row) => {
    const data = await SendEmail(row.id);

   
    setRows((prev) => prev.map((item) => (item.id === row.id ? { ...item, is_active: 1 } : item)));
        setToast({ open: true, message: data.message, severity: data.status });

  }, []);



  const onDelete = useCallback(async (id) => {
    await deleteUser(id);
    setToast({ open: true, message: 'Użytkownik usunięty', severity: 'success' });
    fetchData();
  }, []);

  const onCreate = useCallback(() => {
    setEditing(null);
    setForm({ name: '', email: '', role: '', company: '', us_type: ''  });
    setOpen(true);
  }, []);
  const submitForm = useCallback(async () => {
    if (editing) {
      await updateUser(editing.id, form);
      setToast({ open: true, message: 'Użytkownik zaktualizowany', severity: 'success' });
    } else {
      await createUser(form);
      setToast({ open: true, message: 'Użytkownik utworzony', severity: 'success' });
    }
    setOpen(false);
    fetchData();
  }, [editing,form]);
 const iconMap = {
  us: BsPerson,
  comp: BsBuilding
 
};
 const colorMap = {
      us: 'text-gray-800',
      comp: 'text-amber-500'
    
    };
  const columns = useMemo(() => ([
 {
        field: 'Count',
        headerName: 'Dane użytkownika',
        flex: 1,
        renderCell: (params) => {
          const row = params.row;
          const Icon = iconMap[row.us_type] || BsBuilding; // fallback, jeśli brak
 const iconColor = colorMap[row.us_type] || 'text-gray-400';
          return (
            <div className="flex items-center gap-2">
        {/* Ikona po lewej */}
        <Icon className={`${iconColor} w-5 h-5 flex-shrink-0`} />

        {/* Tekst obok w kolumnie */}
        <div className="flex flex-col leading-tight">
          <span className="font-medium text-gray-900">{row.us_name}</span>
          <span className="text-gray-400 text-xs">{row.email}</span>
        </div>
      </div>
          );
        }
      },
    { field: 'us_login', headerName: 'Login', flex: 1 },
    { field: 'role_name', headerName: 'Rola', width: 150 },
    { field: 'CompnyName', headerName: 'Firma' },
    { field: 'CompanyNIP', headerName: 'NIP'  },

   {
  field: "is_active",
  headerName: "Wysłano",
  flex: 1,
  width:80,
  renderCell: ({ value }) => {
    const active = Number(value) === 1;
    return (
      <div className="flex items-center justify-center w-full">
        <BsMailbox
          className={`font-medium w-4 h-4 ${
            active ? "text-green-700" : "text-primary-200"
          }`}
        />
      </div>
    );
  },
   },
    {
      field: 'actions', width:50, headerName: 'Akcje', sortable: false,isEnd: 1,
     
       renderCell: (params) => (
        <div className="flex gap-2">
                  <UsersAction row={params.row}  onEdit={onEdit} onDelete={onDelete} onSendUserData={onSendUserData} />

      </div>
      )
    }
  ]), [onEdit, onDelete,onSendUserData]);

  const filteredRows = useMemo(() => {
    const term = q.trim().toLowerCase();
    return rows.filter(u => {
      const byTerm = !term || u.name.toLowerCase().includes(term) || u.email.toLowerCase().includes(term);
      const byRole = roleFilter === 'all' || u.role === roleFilter;
      const byActive = activeFilter === 'all' || String(u.active) === activeFilter;
      return byTerm && byRole && byActive;
    });
  }, [rows, q, roleFilter, activeFilter]);

  const total = rows.length;
  const activeCount = rows.filter(r => r.active).length;
  const managers = rows.filter(r => r.role === 'manager').length;
  const usersCount = rows.filter(r => r.role === 'user').length;

  return (
    <div>
      <PageHeaderPortal
      
        title="Użytkownicy"
        subtitle="Zarządzaj kontami, rolami i statusem aktywności"
        actions={(
          <Button variant="contained" onClick={onCreate} size="medium" className="w-full sm:w-auto">
            Dodaj użytkownika
          </Button>
        )}
      />

      <div className="hidden grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-3">
        <StatCard label="Łącznie" value={total} color="blue" />
        <StatCard label="Aktywni" value={activeCount} color="green" />
        <StatCard label="Managerowie" value={managers} color="purple" />
        <StatCard label="Użytkownicy" value={usersCount} color="orange" />
      </div> 

      <div className="w-full rounded-sm bg-white p-3 sm:p-4 lg:p-5 border border-gray-200 mb-3">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-3 w-full sm:max-w-3xl">
            <Input label="Szukaj" value={q} onChange={e => setQ(e.target.value)} size="small" fullWidth placeholder="Imię, nazwisko, firma, NIP..." />
            <Select label="Rola" value={roleFilter} onChange={e => setRoleFilter(e.target.value)} size="small" fullWidth options={[
              { value: 'all', label: 'Wszystkie' },
              { value: 'user', label: 'User' },
              { value: 'manager', label: 'Manager' }
            ]} />
            <Select label="Aktywność" value={activeFilter} onChange={e => setActiveFilter(e.target.value)} size="small" fullWidth options={[
              { value: 'all', label: 'Wszyscy' },
              { value: 'true', label: 'Aktywni' },
              { value: 'false', label: 'Nieaktywni' }
            ]} />
          </div>
          <div className="flex gap-2">
            <Button variant="outlined" onClick={() => { setQ(''); setRoleFilter('all'); setActiveFilter('all'); }}>Wyczyść</Button>
          </div>
        </div>
      </div>

      <div className="rounded-sm overflow-hidden">
        <Table 
          columns={columns} 
          data={filteredRows} 
          loading={loading}
        />
      </div>

      <UserDialog
      width="w-[500px]"
  open={open}
  editing={editing}
  form={form}
  setForm={setForm}
  options={options}
  onClose={() => setOpen(false)}
  onSubmit={submitForm}
/>
    
        
          <Snackbar open={toast.open} message={toast.message} onClose={() => setToast({ ...toast, open: false })} severity={toast.severity} className="shadow-lg">
           
          </Snackbar>
       
     
    </div>
  );
}
